module.exports = __webpack_public_path__ + "img/room2.341fa44d.png";